import TenantedDeploymentParticipationSelector from "./TenantedDeploymentParticipationSelector";
export default TenantedDeploymentParticipationSelector;
